import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setDealType } from 'bundles/apex/deals/form/store/deal/actions';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export function DealType({ allowTypeChange, deal, options, setDealType }) {
  if (deal.id || !allowTypeChange) {
    return null;
  }

  return (
    <ManagedFormGroup
      includeBlank
      label="Deal Type"
      required
      type="select"
      value={deal.dealType}
      onValueChange={setDealType}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </ManagedFormGroup>
  );
}

DealType.propTypes = {
  allowTypeChange: PropTypes.bool,
  deal: PropTypes.shape({
    dealType: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setDealType: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  allowTypeChange: state.allowTypeChange,
  deal: state.deal,
  options: state.options.dealType,
});

const mapDispatchToProps = {
  setDealType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealType);
